# GraphQL fragment to select the calendar for sync

#import "../fragments/calendar-fragment.graphql"

mutation SelectCalendarSyncCalendar($calendar: SelectCalendarSyncCalendarInputFieldInput!) {
    selectCalendarSyncCalendar(input: {calendar: $calendar}) {
        calendars {
            ...CalendarFragment
        }
    }
}
